<div class="box-border flex w-full flex-col bg-inherit text-base">
  @let hasError = ngControl.errors && ngControl.touched;

  <div
    class="group relative w-full bg-inherit"
    [ngClass]="{
      'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    }">
    @for (option of options(); track $index; let index = $index) {
      <aw-checkbox
        class="my-3 block px-3 py-2"
        [id]="id() | appendTestId: index + ''"
        [label]="(option | toSelectOptionAttribute: name()) + ''"
        [formControl]="optionControls[index]"
        (valueChange)="selectOption(option)"
        (keyup.enter)="$event.preventDefault(); selectOption(option)" />
    }
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
